import React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SettingsContent } from '@/components/residents/redesign/settings';
import { useSettingsScreen } from '@/hooks/residents/useSettingsScreen';

export const ResidentProfileScreen: React.FC = () => {
  const insets = useSafeAreaInsets();
  const settings = useSettingsScreen();

  return (
    <SettingsContent
      displayName={settings.displayName}
      email={settings.email}
      propertyUnit={settings.propertyUnit}
      initials={settings.initials}
      appVersion={settings.appVersion}
      shouldShowPayments={settings.shouldShowPayments}
      isSendingVerification={settings.isSendingVerification}
      isLoggingOut={settings.isLoggingOut}
      isDarkMode={settings.isDarkMode}
      communityUpdatesEnabled={settings.communityUpdatesEnabled}
      stagedRoommateEmail={settings.stagedRoommateEmail}
      stagedRoommatePhone={settings.stagedRoommatePhone}
      onProfilePress={settings.handleProfilePress}
      onLinkedAccountsPress={settings.handleLinkedAccountsPress}
      onChangePassword={settings.handleChangePassword}
      onPaymentMethodsPress={settings.handlePaymentMethodsPress}
      onAutopayPress={settings.handleAutopayPress}
      onToggleTheme={settings.handleToggleTheme}
      onToggleCommunityUpdates={settings.handleToggleCommunityUpdates}
      onToggleRoommateEmail={settings.setStagedRoommateEmail}
      onToggleRoommatePhone={settings.setStagedRoommatePhone}
      onHowItWorksPress={settings.handleHowItWorksPress}
      onTutorialPress={settings.handleTutorialPress}
      onFeedbackPress={settings.handleFeedbackPress}
      onLogout={settings.handleLogout}
      onDeleteAccountPress={settings.handleDeleteAccountPress}
      contentPaddingBottom={40 + insets.bottom}
    />
  );
};
